import React, { Component } from 'react'

import ResultsList from './ResultsList'

export default class ModalResults extends Component {
	constructor(props) {
		super(props)

		this.modal = React.createRef()
		this.handleClick = this.handleClick.bind(this)
	}

	componentDidMount() {
		document.addEventListener('keydown', this.props.handleKeydown, false)
	}

	componentWillUnmount() {
    document.removeEventListener('keydown', this.props.handleKeydown, false)
  }

	handleClick(e) {
	  // Otherwise clicks on child elements will trigger handleClose.
	  if (this.modal && e.target === this.modal.current) {
	    this.props.handleClose()
	  }
	}

	render() {
		document.body.style.cssText = this.props.active ? 'overflow: hidden' : '' // Prevent scrolling rest of page when modal open.
		const iconClass = this.props.loading ? 'loading' : 'fa fa-search'
		
		return !this.props.active ? null : (
			<>
			<div className="modal-open">
			  <div onClick={this.handleClick} ref={this.modal} className="modal-fade-screen modal-grey">
			    <div className="modal-inner">
			      <div className="modal-close" onClick={this.props.handleClose}></div>
			      <div className="search-results-wrapper">
			        <div className="top-bar">
			          <div className="nav-search-input-wrap">
			            <div>
			              <input
			                type="text"
			                autoFocus
			                autoComplete="off"
			                name="q"
			                className="nav-search-input"
			                placeholder="Search"
			                value={this.props.searchTerm}
			                onChange={this.props.handleChange}
			                ref={this.props.searchInput}
			              />
			              <i className={iconClass}></i>
			            </div>
			          </div>
                <div className="search-info">
			            <p className="search-hint">Tip: start a search anywhere by typing - no need to click Search</p>
			            <p className="result-total">{this.props.numResults} results</p>
                </div>
			        </div>
			        <ResultsList 
			        	groups={this.props.groups} 
			        	focusable={this.props.focusable} 
			        	selected={this.props.selected}
			        	selectResult={this.props.selectResult}
			        />
			      </div>
			    </div>
			  </div>
			</div>
			</>
		)
	}
}